import { Badge } from "@/components/ui/Badge";
import { Show } from "solid-js";
import { ActionDropdown, ActivateDropdownItem, DeactivateDropdownItem, DeleteDropdownItem, EditDropdownMenuItem } from "../../components/ui/actions/ActionDropdown";
import { activateAction, deactivateAction, deleteAction } from "../../components/ui/actions/config";

export const getRoomColumns = ({ onListAction, onEdit }) => {

  const actionUrl = 'room';
  const entity = 'room';

  const onAction = (action, key) => {
    if (action === 'edit') {
      onEdit(key);
      return;
    }

    if (action === 'deactivate') {
      onListAction(deactivateAction(actionUrl, entity), key);
      return;
    }

    if (action === 'activate') {
      onListAction(activateAction(actionUrl, entity), key);
      return;
    }

    if (action === 'delete') {
      onListAction(deleteAction(actionUrl, entity), key);
      return;
    }
  }

  return [
    {
      title: 'Room',
      key: 'name',
      sort: true,
      render: (row) => row.name
    },
    {
      title: 'Status',
      key: 'isActive',
      render: (row) => {
        return <Badge variant={row.isActive ? 'success' : 'warning'}>{row.isActive ? 'Active' : 'Inactive'}</Badge>
      }
    },
    {
      title: '',
      isPlaceholder: true,
      key: null,
      render: (row) => {
        return (
          <div class="flex gap-2 items-center">
            <ActionDropdown asIcon>
              <EditDropdownMenuItem onClick={() => { onAction('edit', row.key) }} />
              <Show when={!row.isActive}>
                <ActivateDropdownItem onClick={() => { onAction('activate', row.key) }} />
              </Show>
              <Show when={row.isActive}>
                <DeactivateDropdownItem onClick={() => { onAction('deactivate', row.key) }} />
              </Show>
              <DeleteDropdownItem onClick={() => { onAction('delete', row.key) }} />
            </ActionDropdown>
          </div>
        );
      }
    }
  ];
}
